import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { post } from '@network/api';
import { getErrorMessage } from '@lib/handle-error';
import { AccountBindingInfo } from '@pages/types';

const UnbindButton = ({
  disabled,
  settings,
  accountBinding,
}: {
  disabled?: boolean;
  settings?: {
    primary_color?: string;
    button_text_color?: string;
  };
  onGoBack: () => void;
  accountBinding?: AccountBindingInfo;
}) => {
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { id } = query as { id?: string };
  const [isLoadingUbind, setIsLoadingUnbind] = useState(false);

  const handleBindAccount = async (partnerRefNo: string): Promise<void> => {
    if (!id) {
      toast.error('Invoice ID is missing');
      return;
    }

    setIsLoadingUnbind(true);

    try {
      await post('/checkout/v1/payment/account-unbind', {
        invoice_number: id,
        partner_reference_no: partnerRefNo,
      });
      toast.success('Account unbound successfully');
      window.location.reload();
    } catch (error: unknown) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsLoadingUnbind(false);
    }
  };

  return (
    <button
      type="button"
      disabled={disabled || isLoadingUbind}
      className="flex w-full items-center justify-center rounded-lg px-4 py-3 font-semibold transition-all hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
      style={{
        backgroundColor: settings?.primary_color || '#EBF2FF',
        color: settings?.button_text_color || '#2d2e2f',
        border: `1px solid ${settings?.primary_color || '#e5e7eb'}`,
      }}
      onClick={() =>
        handleBindAccount(accountBinding?.partner_reference_no || '')
      }
    >
      Unbind Account
    </button>
  );
};

export default UnbindButton;
